<div *ngIf="information">
  <h2 *ngIf="information.ingress" [translate]="information.ingress"></h2>
  <p *ngIf="information.content" [translate]="information.content"></p>
</div>
